<ng-container *ngIf="IsNonActivated; else defaultTpl">
  <!--NON ACTIVE-->
  <div class="">
    <app-card-document [bodyList]="detailDocumentDistributor" [loading]="isLoading" [title]="'Dokumen Distributor'"></app-card-document>
    <div class="my-7">
      <app-card-document [bodyList]="detailDocumentNpwp" [loading]="isLoading" [title]="'Dokumen NPWP'"></app-card-document>
    </div>
    <div class="my-7">
      <app-card-document [bodyList]="detailDocumentActivation" [loading]="isLoading" [title]="'Dokumen Aktivasi'"></app-card-document>
    </div>
    <ng-container *ngTemplateOutlet="documentNonActiveTpl"></ng-container>
  </div>
</ng-container>

<ng-template #defaultTpl>
  <div class="mb-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataDocument.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.DOCUMENT)"
      [dataValue]="dataValueDocumentStep"
      [sessionKey]="revisionType"
      [isLoading]="isLoading"
      [withBadgeCheck]="ShowBadge"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValueDocumentStep.value.document)"
      [isViewOnly]="isViewOnly"
      [status]="dataValueDocumentStep.value.document?.status_verified_enum"
      [title]="'Dokumen'"
      [typeSection]="EnumCardVerificationSection.DOCUMENT"
      [type]="EnumCardVerificationForm.DOCUMENT"
    />
  </div>
  <div *ngIf="isShowDataUpdateDocument()" class="my-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyDataUpdateDocument]="bodyDataUpdateDocument.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.DOCUMENT_UPDATE_DISTRIBUTOR)"
      [sessionKey]="revisionType"
      [dataValue]="dataValueDocumentStep"
      [withBadgeCheck]="ShowBadge"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValueDocumentStep.value.document_update_distributor)"
      [isViewOnly]="isViewOnly"
      [status]="bodyDataUpdateDocument.value?.status_verified_enum"
      [title]="'Dokumen Pembaruan Data'"
      [typeSection]="EnumCardVerificationSection.DOCUMENT_UPDATE_DISTRIBUTOR"
      [type]="EnumCardVerificationForm.UPDATE_DOCUMENT"
    />
  </div>
</ng-template>

<ng-template #documentNonActiveTpl>
  <app-card [cardClasses]="'my-8'" [cardBodyClasses]="'pt-0'" [header]="true">
    <!-- header start -->
    <ng-container cardHeader>
      <h5 class="fw-bolder d-flex w-100 align-items-center mb-0">
        <span>Dokumen Penonaktifan</span>
      </h5>
    </ng-container>

    <ng-container cardBody>
      <div class="row">
        <div class="col-12 col-lg-6">
          <app-document-preview [data]="documentNonActive"></app-document-preview>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
